import {
  DOWNLOAD_ACTION,
  TRANSACTION_DOWNLOAD_ACTIONS
} from '../../../constants/actions'
import { mergeToNewObject } from '../../../util/object.helpers'

export const transactionsDownloadProfile = (
  state = INITIAL_STATE,
  { type, payload }
) => {
  switch (type) {
    case TRANSACTION_DOWNLOAD_ACTIONS.ON_GET_TRANSACTIONS_FOR_DOWNLOAD:
      return mergeToNewObject(state, {
        transactionsData: [],
        isProcessing: true
      })

    case TRANSACTION_DOWNLOAD_ACTIONS.ON_GET_TRANSACTIONS_FOR_DOWNLOAD_SUCCESS:
      return mergeToNewObject(state, {
        transactionsData: payload,
        isProcessing: false
      })

    case TRANSACTION_DOWNLOAD_ACTIONS.ON_GET_TRANSACTIONS_FOR_DOWNLOAD_FAILED:
    case DOWNLOAD_ACTION.ON_SENT_REPORT_IN_EMAIL_SUCCESS:
    case DOWNLOAD_ACTION.ON_SENT_REPORT_IN_EMAIL_FAILED:
      return mergeToNewObject(state, { isProcessing: false })

    case TRANSACTION_DOWNLOAD_ACTIONS.ON_RESET_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  transactionsData: [],
  isProcessing: false
}
